import avalanche from './avalanche.svg'
import avax from './avax.svg'
import spusdc from './spusdc.svg'
import usdc from './usdc.svg'
import wavax from './wavax.svg'

export const tokenLogos = {
  usdc,
  spusdc,
  wavax,
  avax,
}

export const chainLogo = avalanche
